export const loginI18nFallbacks = {
  // Key names below (WELCOME_TEXT, WELCOME_TEXT_GRADIENT,
  // WELCOME_DESCRIPTION) match the generic-module UILM keys the Angular
  // app's login page already uses -- do not rename these back to invented
  // names.
  WELCOME: 'Welcome',
  CONTINUE_LOGIN_SSO: 'Please continue to log in with your company account.',
  WELCOME_TEXT: 'Seamless HR Integration, Your one Stop',
  WELCOME_TEXT_GRADIENT: 'HR Solution Hub',
  WELCOME_DESCRIPTION:
    'One hub, seamless HR solutions. From daily attendance to performance evaluation, all unified for streamlined efficiency.',
  CONTINUE_WITH_PROVIDER: 'Continue with {{provider}}',
  LOGIN_REDIRECTING: 'Redirecting...',
  LOGIN_REDIRECT_HINT: "You'll be taken to the secure SELISE sign-in page.",
  FOOTER_COPYRIGHT: '© {{year}} SELISE Digital Platforms',
} as const;
